import Header from '@/components/Header/Header';
import useToggle from '@/hook/useToggle';
import LoginMain from '@/pages/login/components/main';
import { onAccountDrawerClose } from '@/redux/slices/app';
import { dispatch } from '@/redux/store';
import { SettingsContext } from '@/SettingsProvider';
import { changeLocale } from '@/utils/dateUtils';
import { getUrlParams } from '@/utils/utils';
import { Box, styled } from "@mui/material";
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PromoView from './components/PromoView';
import { getToken, setTaskId, setTaskRuleParams } from '@/redux/slices/user';
import { createSearchParams, useNavigate } from 'react-router-dom';
import RouteConstant from '@/constant/RouteConstant';


const StyledBox = styled(Box)(({theme}) => ({
  // background: 'url(/images/login-bg.svg) no-repeat center',
  // backgroundSize: '100% 100%',
}))

function Login() {
  const navigate = useNavigate();
  const {
    toggle: showPromo,
    onToggle: onToggleShowPromo,
    setToggle: setToggleShowPromo,
  } = useToggle(false);
  const { t, i18n } = useTranslation();

  const {
    updateSetting,
    settings,
  } = useContext(SettingsContext)
  const [mode, setMode] = useState("login");

  useEffect(() => {
    if (getToken()) {
      navigate(RouteConstant.MAIN);
    } else {
      setTaskId(null);
      setTaskRuleParams(null);
      
      const mode = getUrlParams('mode');
      if (mode) {
        setToggleShowPromo(false);
        setMode(mode);
      }
    }
  }, []);

  useEffect(() => {
    let lang = getUrlParams('lang');
    // 如果params 包含lang，设置语言
    if (lang) {
      handleChangeLanguage(lang);  
    }

    dispatch(onAccountDrawerClose());
  }, []);

  const handleChangeLanguage = (language) => {
    const newSettings = {
      lang: language,
    }

    // ar will using rtl direction layout.
    if (language === 'ar') {
      newSettings.direction = 'rtl'
    } else {
      newSettings.direction = 'ltr'
    }

    i18n.changeLanguage(language)
    changeLocale(language)
    updateSetting(newSettings)
  }

  const _onPromoGoTo = () => {
    navigate({
      pathname: RouteConstant.LOGIN,
      search: createSearchParams({
        'mode': 'register'
      }).toString()
    });
  }
  return (
    <StyledBox>
      {showPromo ? <PromoView onGoTo={_onPromoGoTo} /> : <Box>
        <Header/>
        <LoginMain mode={mode}/>
      </Box>}
    </StyledBox>
  );
}

export default Login;
